// @flow

import { RECEIVED_CONFIGURATOR_SETTINGS } from './constants';
import type { ReceivedConfiguratorSettings } from './actions';

const initialState = {
  bestseller_label: '',
  price_label: '',
  baseprice_label: '',
  sold_out_text: '',
  in_bundle: '',
  in_package: '',
  in_stock_text: '',
  non_recurring_text: '',
  mileage_abbreviation: '',
  contract_duration_abbreviation: '',
  delivery_time_duration_single: '',
  delivery_time_duration_plural: '',
  order_buttons_information_text: '',
  fast_delivery_time_duration_single: '',
  fast_delivery_time_duration_plural: '',
  mileage: '',
  packages: {
    usp_features_label: '',
    compare_collapsed_button_text: '',
    compare_expanded_button_text: '',
  },
  collapsible_config_choice_button: {
    collapsed: '',
    expanded: '',
  },
  cart: {
    package_label: '',
    color_label: '',
    claim_free_label: '',
    delivery_time_label: '',
    duration_label: '',
    mileage_label: '',
    bundle_label: '',
    extra_label: '',
    insurance_label: '',
    price_per_month_label: '',
    model_label: '',
    tax_note: '',
    roadtax_note: '',
    per: '',
    month: '',
    year: '',
    per_month_abbrv: '',
    cart_header: '',
    including_abbreviation: '',
    buttons: {
      order_lease_object: '',
      mail_offer: '',
      close: '',
    },
  },
  save_config: {
    title: '',
    content: '',
  },
  vbmr: {
    show_activate_overlay: false,
    activate_title: '',
    activate_description: '',
    activate_accept_button_text: '',
    activate_decline_button_text: '',
    show_deactivate_overlay: false,
    deactivate_title: '',
    deactivate_description: '',
    deactivate_accept_button_text: '',
    deactivate_decline_button_text: '',
    vbmr_active_text: 'Order Today, Receive Tomorrow',
  },
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedConfiguratorSettings): State => {
  switch (action.type) {
    case RECEIVED_CONFIGURATOR_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
